import axios from '_u/axios'

// 客户列表
export const customerList = (body) => {
    return axios.post('api/customer/info/list', body)
}

// 查询客户详情
export const customerView = (id) => {
    return axios.post('api/customer/info/view', { id })
}

// 新增客户
export const customerAdd = (body) => {
    return axios.post('api/customer/info/add', body)
}

// 修改客户
export const customerUpdate = (body) => {
    return axios.post('api/customer/info/update', body)
}

// 删除
export const customerDelete = (id) => {
    return axios.post('api/customer/info/delete', { id })
}

// 外部用户列表
export const customerUserList = (body) => {
    return axios.post('api/customer/user/list', body)
}

// 查询外部用户详情
export const customerUserView = (id) => {
    return axios.post('api/customer/user/view', { id })
}

// 新增外部用户
export const customerUserAdd = (body) => {
    return axios.post('api/customer/user/add', body)
}

// 修改外部用户
export const customerUserUpdate = (body) => {
    return axios.post('api/customer/user/update', body)
}

// 删除外部用户
export const customerUserDelete = (id) => {
    return axios.post('api/customer/user/delete', { id })
}

// 重置外部用户密码
export const customerUserResetPwd = (id) => {
    return axios.post('api/customer/user/resetPwd', { id })
}